import React, { useState, useEffect } from 'react';
import '../styles/multiviewerStyles.css';
import { SwitchField, Button, useTheme } from '@aws-amplify/ui-react';
import Switch from '@mui/material/Switch';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { API } from 'aws-amplify';
import { getVideoPlayerUrl } from '../utils/helpers.js';
import VideoPlayer from '../components/videoPlayer';

const myAPI = "api94d03d7c"
const addActionPath = "/multiviewer-status"


  
export default function Multiviewer (){
    
    const { tokens } = useTheme();
    
    const playerUrlBravoEast = getVideoPlayerUrl("Bravo-East");
    const playerUrlBravoWest = getVideoPlayerUrl("Bravo-West");
    const playerUrlCNBC = getVideoPlayerUrl("CNBC");
    const playerUrlEEast = getVideoPlayerUrl("E-East");

    return (
        <section>
            <div className="multiviewer-container">
                <div className="multiviewer-player-label-div">
                    <p>Bravo East</p>
                    <VideoPlayer channelName={"BravoEast"} isMultiViewer={true} videoURL={playerUrlBravoEast} />
                </div>
                <div className="multiviewer-player-label-div">
                    <p>Bravo West</p>
                    <VideoPlayer channelName={"BravoWest"} isMultiViewer={true} videoURL={playerUrlBravoWest}/>
                </div> 
                <div className="multiviewer-player-label-div">
                    <p>CNBC</p>
                    <VideoPlayer channelName={"CNBC"} isMultiViewer={true} videoURL={playerUrlCNBC} /> 
                </div> 
                <div></div> 
                <div></div> 
                <div></div> 
                <div></div> 
                <div></div> 
                <div></div> 
                <div></div> 
                <div></div>
                <div></div> 
                <div></div> 
                <div></div> 
                <div></div> 
                <div></div> 
                <div></div> 
                <div></div> 
                <div></div> 
                <div></div> 
                <div></div> 
                <div></div> 
                <div></div> 
                <div></div> 
                <div></div> 
                <div></div> 
                <div></div> 
                <div></div> 
                <div></div> 
                <div></div> 
                <div></div> 
            </div>
        </section>
    )
}